import { get } from "lodash";
import { useSelector } from "react-redux";
import { getAppConfig, getLanguage } from "../store/sagas/selectors";

export const useText = (): ((id: string, fallback?: unknown) => string) => {
    const appConfig = useSelector(getAppConfig);
    const language = useSelector(getLanguage);
    return (id, fallback?) => get(appConfig, `translations.${language}.${id}`, fallback);
};
